// test1548
(1548 && 0);
